import { EPIC_BANNER } from "./constants";

export default function EpicBanner() {
  return (
    <section className="py-12 bg-cvc-cream">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <p className="text-[10px] tracking-[0.3em] uppercase font-body font-semibold text-cvc-red text-center">One family of services — Two ways to scale</p>
        <img
          src={EPIC_BANNER}
          alt="Epic Enterprises Consulting with its Cache Valley Consulting and ScaledEasy programs at work — Jonathan on a shop floor, a ScaledEasy consultant at her desk, and live group consulting sessions."
          loading="lazy"
          className="mt-4 w-full rounded-2xl border border-cvc-border shadow-sm"
        />
      </div>
    </section>
  );
}
